import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import '@digital-realty/ix-progress/ix-progress.js';
import '@digital-realty/ix-drawer/ix-drawer.js';
import { TWStyles } from '../styles/tw.js';

export type TAppVersion = {
  [key: string]: {
    [key: string]: string;
  };
};

export class IxAppVersions extends LitElement {
  static styles = [TWStyles];

  @property({ type: Boolean }) isVisible = false;

  @property({ type: Boolean }) isLoading = false;

  @property({ type: Array, attribute: 'app-versions' })
  appVersions: TAppVersion[] = [];

  versionsRequest?: () => Promise<TAppVersion[]> = undefined;

  async firstUpdated() {
    if (this.versionsRequest) {
      this.isLoading = true;
      this.appVersions = await this.versionsRequest();
      this.isLoading = false;
    }
  }

  private _handleClose = () => {
    this.dispatchEvent(new CustomEvent('closed'));
  };

  renderAppVersions() {
    if (!this.appVersions.length) {
      return html` <p>Failed to get app versions.</p> `;
    }

    return html`
      <ul>
        ${this.appVersions.map(app =>
          Object.keys(app).map(
            appName =>
              html`<li>
                <h2 class="dlr-text-heading">${appName}</h2>
                <dl class="mt-2 mb-4 flex flex-wrap gap-8">
                  ${Object.keys(app[appName]).map(
                    versionKey => html`
                      <div>
                        <dt class="dlr-text-small font-bold">${versionKey}</dt>
                        <dd>${app[appName][versionKey]}</dd>
                      </div>
                    `,
                  )}
                </dl>
              </li>`,
          ),
        )}
      </ul>
    `;
  }

  render() {
    return html`
      <ix-drawer .onClosed=${this._handleClose} ?isVisible=${this.isVisible}>
        <section slot="content">
          <h1 class="dlr-text-page-title mb-6">Versions</h1>
          ${this.isLoading
            ? html`
                <ix-progress
                  class="flex justify-center"
                  .linear=${false}
                  .indeterminate=${true}
                ></ix-progress>
              `
            : this.renderAppVersions()}
        </section>
      </ix-drawer>
    `;
  }
}

window.customElements.define('ix-app-versions', IxAppVersions);
